import * as actionTypes from '../actions/actionTypes';

const initState = {
  loading: false,
  authenticated: false,
  role: '',
  token: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return { ...state, loading: true };
    case actionTypes.AUTH_SUCCESS:
      const { token, role } = action;
      return { ...state, loading: false, authenticated: true, token, role };
    case actionTypes.AUTH_FAIL:
      return { ...state, loading: false };
    case actionTypes.AUTH_LOGOUT:
      return initState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js